import {createApp} from 'vue';
import ProductLandingPage from '../organization-payments/product-landing-page';
import {createRouter, createWebHistory} from 'vue-router';
import Toaster from '@meforma/vue-toaster';
import { installInlineSvgHelpers } from '../utils/register-inline-svg.js';

const router = createRouter({
    history: createWebHistory(),
    routes: [],
});

const app = createApp(ProductLandingPage);

installInlineSvgHelpers(app);

app.use(router);
app.use(Toaster);
document.addEventListener('DOMContentLoaded', () => {
    const appContainer = document.createElement('div');
    document.body.appendChild(appContainer);
    app.mount(appContainer);
});